import * as React from "react";
import { DragOverlay } from "@dnd-kit/core";
import styled from "styled-components";
import { createPortal } from "react-dom";
import zIndices from "theme/z-indices";
import ListItem from "components/common/SortableList/ListItem";
import { ListGroup } from "components/bootstrap";
const SortableListItemOverlay = styled(ListItem)`
  box-shadow:
    rgb(0 0 0 / 5%) 0 1px 3px 0,
    rgb(0 0 0 / 5%) 0 28px 23px -7px,
    rgb(0 0 0 / 4%) 0 12px 12px -7px;
`;
const ListItemDragOverlay = ({
  activeId,
  alignItemContent = void 0,
  customContentRender = void 0,
  customListItemRender = void 0,
  displayOverlayInPortal,
  items
}) => {
  const activeItemIndex = activeId ? items.findIndex((item) => item.id === activeId) : -1;
  const activeItem = activeId ? items[activeItemIndex] : null;
  const dragOverlay = /* @__PURE__ */ React.createElement(DragOverlay, { zIndex: zIndices.modalBody }, activeItem ? /* @__PURE__ */ React.createElement(ListGroup, null, /* @__PURE__ */ React.createElement(
    SortableListItemOverlay,
    {
      isDragging: true,
      alignItemContent,
      customContentRender,
      customListItemRender,
      dragHandleProps: {},
      index: activeItemIndex,
      item: activeItem
    }
  )) : null);
  return displayOverlayInPortal ? createPortal(dragOverlay, document.body) : dragOverlay;
};
export default ListItemDragOverlay;
